import { SxProps, Theme } from '@mui/material/styles';

export const tooltipSx: SxProps<Theme> = {};
